// Port of api/fuel/app/classes/insights/records/init.php

import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Config from 'offline/model/config'

export default Segment.extend({
	name: 'init',
	priority: 10,
	run: function(type, owner, userIndex) {

		var noConfigIndex = []
		var where = []

		this._data.join = 'pr.user_id = pl.user_id'

		for (var i = 0; i < userIndex.length; i++) {
			var userId = userIndex[i]
			var config = Config.user(userId)

			if (config.insights && config.insights.records && config.insights.records.start) {
				var configWhere = ['pl.user_id = ' + userId]
				configWhere.push('pl.play_date >= ' + config.insights.records.start)
				where.push('(' + configWhere.join(' AND ') + ')')
			} else {
				noConfigIndex.push(userId)
			}
		}

		if (noConfigIndex.length) {
			where.push('pl.user_id IN (' + Util.in(noConfigIndex) + ')')
		}

		var whereSql = where.length > 1 ? '(' + where.join(' OR ') + ')' : (where[0] || '1=0')

		// Hot loop: 2,758 plays for nicknelson, 8 columns, 22k object
		// property writes. Util.queryFast bypasses per-row getAsObject()
		// for ~2x faster materialization.
		this._data.plays = Util.queryFast(
			'SELECT pl.play_id AS play, pl.user_id AS user, pl.game_id AS game, pl.play_date AS date,' +
			' pl.play_players AS players, pl.play_count AS count, pl.play_won AS won, pl.play_result AS result' +
			' FROM play pl' +
			' WHERE ' + whereSql +
			' AND pl.play_expansion = 0' +
			' AND pl.play_date > 0' +
			' ORDER BY pl.play_date ASC, pl.play_id ASC'
		)

		return {}

	}
})
